import { useLayoutEffect } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import MainContainer from "../../components/container/MainContainer";
import PageTitle from "../../components/titles/PageTitle";
import Loading from "../../components/loading/Loading";
import TextContainer from "../../components/text/TextContainer";
import Modal from "../../components/modal/Modal";
import { openModal } from "../../features/modalSLice";
import { useAuthorization } from "../../hooks/useAuthorization";
import { getDonor } from "../../features/donorsSlice";
import loadStatus from "../../util/loadStatus";
import NetworkError from "../error/NetworkError";
import AddNation from "./AddNation";
import DeleteNation from "./DeleteNation";
import { getNation, unsetSelectedNation } from "../../features/nationsSlice";
import { ChevronLeft, FilePen, Trash2 } from "lucide-react";
import { capitalizeFirst } from "../../util";

const SingleNation = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const location = useLocation();
  const { isAuthorized } = useAuthorization();
  const modalContent = useSelector((state) => state.modal.content);
  const nation = useSelector((state) => state.nations.selected);
  const loading = useSelector((state) => state.nations.load.getNation);

  const openEditNationModal = (edit, id) => {
    dispatch(openModal(<AddNation edit={edit} id={id} />));
  };

  const openDeleteNationModal = (id) => {
    dispatch(openModal(<DeleteNation id={id} />));
  };

  useLayoutEffect(() => {
    dispatch(getNation(id));

    return () => {
      dispatch(unsetSelectedNation());
    };
  }, []);

  if (loading === loadStatus.loading) {
    return <Loading />;
  }

  if (loading === loadStatus.error) {
    return <NetworkError to={location.pathname} />;
  }

  return (
    <MainContainer>
      <Modal>{modalContent}</Modal>
      {nation.id && (
        <>
          <PageTitle title={`Natioinal - ${nation.name}`} />
          <div className="bg-content  border border-bkg2 rounded-md p-7 mb-5 !text-text-1/55">
            <TextContainer label="Name" content={`${nation.name}`} />

            <TextContainer
              label="Type"
              content={capitalizeFirst(nation.type)}
            />
            <TextContainer label="Address 1" content={nation.address1} />
            <TextContainer label="Address 2" content={nation.address2} />

            <TextContainer label="Email" content={nation.email || "N/A"} />
            <TextContainer label="Mobile" content={nation.phone || "N/A"} />
            <TextContainer label="Phone" content={nation.phone2 || "N/A"} />
            <TextContainer
              label="Province"
              content={nation.province?.name || "N/A"}
            />
            <TextContainer label="Country" content={nation.country || "N/A"} />
          </div>
          <div className="p-7 border border-bkg2 rounded-md flex justify-between items-center">
            <Link to="/settings/nations" className="cancel-rss-btn">
              <ChevronLeft size={18} /> Back
            </Link>
            <div className="flex gap-3">
              <button
                onClick={(e) => openEditNationModal(true, id)}
                disabled={!isAuthorized("countries", "update")}
                className="add-rss-btn"
              >
                <FilePen size={18} />
                Edit
              </button>
              <button
                onClick={(e) => openDeleteNationModal(id)}
                disabled={!isAuthorized("countries", "delete")}
                className="delete-rss-btn"
              >
                <Trash2 size={18} />
                Delete
              </button>
            </div>
          </div>
        </>
      )}
    </MainContainer>
  );
};

export default SingleNation;
